import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

export default function CreatorProfile() {
  const { user, myCreator, setMyCreator } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const [avatar, setAvatar] = useState("");
  const [gallery, setGallery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (myCreator) {
      setName(myCreator.name || "");
      setUrl(myCreator.url || "");
      setDescription(myCreator.description || "");
      setAvatar(myCreator.avatar_image_url || "");
      setGallery((myCreator.gallery || []).join(", ") || "");
    }
  }, [myCreator]);

  useEffect(() => {
    if (!user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const payload = {
      name: name.trim(),
      url: url.trim(),
      description: description.trim(),
      avatar_image_url: avatar.trim(),
      gallery: gallery
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    };

    try {
      const res = myCreator
        ? await api.put("/me/creator", payload)
        : await api.post("/me/creator", payload);
      setMyCreator(res.data);
      navigate("/", { replace: true });
    } catch (err) {
      setError(
        err?.response?.data?.detail || err?.response?.data || "Failed to save",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-4">
        {myCreator ? "Edit Creator Profile" : "Become a Creator"}
      </h1>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Name</label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            URL (optional)
          </label>
          <Input value={url} onChange={(e) => setUrl(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Description</label>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            Avatar Image URL
          </label>
          <Input value={avatar} onChange={(e) => setAvatar(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            Gallery (comma separated URLs)
          </label>
          <Input value={gallery} onChange={(e) => setGallery(e.target.value)} />
        </div>
        {error && <div className="text-red-600">{String(error)}</div>}
        <div className="flex items-center gap-3">
          <Button type="submit" disabled={loading} className="px-4 py-2">
            {loading ? "Saving…" : "Save"}
          </Button>
          <Button variant="outline" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}
